import { Route, Routes } from 'react-router-dom';

import { CmsLayout } from '@/features/cms/layouts/CmsLayout';

export const CmsRoutes = () => {
  return (
    <Routes>
      <Route element={<CmsLayout />}>{/* declare webcast routes here */}</Route>
    </Routes>
  );
};
